module.exports = __webpack_public_path__ + "static/media/b.aaceb386.png";